import { AxiosResponse } from "axios";
import API from "../api";

import { Branch } from "../models/branch";

const ROUTE_NAME = "branches";

const BranchService = {
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${ROUTE_NAME}/count`, { params: options });
  },
  async getById(id: number, options?: any): Promise<AxiosResponse<Branch>> {
    return await API.get(`/${ROUTE_NAME}/${id}`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<Branch[]>> {
    return await API.get(`/${ROUTE_NAME}`, { params: options });
  },
  async create(branch: Branch): Promise<AxiosResponse<Branch>> {
    return await API.post(`/${ROUTE_NAME}`, branch);
  },
  async update(id: number, branch: Branch): Promise<AxiosResponse<boolean>> {
    return await API.put(`${ROUTE_NAME}/${id}`, branch);
  },
};

export default BranchService;
